import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from './button.js';
import { cx } from './cx.js';
/**
 * In place of data that did not come - an error that looks like one, never like an empty list
 * or a value (unknown is not no), with „Erneut laden“.
 */
export function LoadError({ failure, className }) {
    return (_jsxs("div", { role: "alert", className: cx('flex flex-wrap items-center gap-3 text-sm text-danger-fg', className), children: [failure.message, _jsx(Button, { variant: "quiet", size: "sm", isPending: failure.isRetrying, onPress: failure.onRetry, children: "Erneut laden" })] }));
}
//# sourceMappingURL=load-error.js.map